import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  email() {
    return faker.internet.email(this.firstname, this.lastname);
  },

  firstname() {
    return faker.name.firstName();
  },

  fon() {
    return faker.phone.number('+49 ## #### ####');
  },

  lastname() {
    return faker.name.lastName();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(person, server) {
    person.update({
      gender: server.create('category', 'gender'),
      positions: server.createList('category', 1, 'position'),
      sections: server.createList('section', 1),
    });
  },
});
